import { Component } from '@angular/core';

@Component({
  selector: 'shared-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'],
  standalone: false,
})
export class LoadingIndicatorComponent {}
